import script from "./Department.vue?vue&type=script&setup=true&lang=js"
export * from "./Department.vue?vue&type=script&setup=true&lang=js"

import "./Department.vue?vue&type=style&index=0&id=bd65d844&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd65d844"]])

export default __exports__